import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ProductService} from '../../../services/product.service';
import {Product, RootObject} from '../../../models/product';
import {RegistryService} from '../../../services/registry.service';
import {CartService} from '../../../services/cart.service';
import {ProductDataSet} from '../../../models/product-data-set';
import {BreadcrumbModel} from '../../../../shared/models/Breadcrumb.class';
import {Title} from "@angular/platform-browser";
import {GoogleAnalyticsService} from "../../../services/google-analytics.service";

@Component({
    selector: 'app-product-details-qr',
    templateUrl: './product-details-qr.component.html',
    styleUrls: ['./product-details-qr.component.css']
})
export class ProductDetailsQrComponent implements OnInit, OnDestroy {

    FullCategories: any[] = [];
    breadScrumbArr: any = [];
    breadScrumb: any = [];

    attributes = [];

    CatsLoadedEvent;


    constructor(private route: ActivatedRoute, public productService: ProductService,
                public registry: RegistryService,
                private googleService:GoogleAnalyticsService,
                private titleService: Title
    ) {

        this.CatsLoadedEvent = this.registry.CatsLoadedEvent$.subscribe(data => {
            this.FullCategories = data;
            this.getPathCategories();
        });


    }

    item: Product;
    image;
    sku: string;
    urlKey: string;
    Cat: any;


    ngOnInit(): void {


        // this.item = this.registry.currentProduct;
        const temp = this.registry.getFullCat();
        if (temp !== undefined || temp?.length > 0) {
            this.FullCategories = temp;
        }

        const sku = this.route.snapshot.paramMap.get('sku');
        const urlKey = this.route.snapshot.paramMap.get('urlKey');




        if (sku != null) {
            if (!this.item || this.item.sku !== sku) {
                this.route.paramMap.subscribe(paramMap => {
                    this.sku = paramMap.get('sku');

                    this.fetchProductsDetailes();
                    // this.getPathCategories();

                });
            } else {
                this.sku = this.item.sku;
                this.fetchProductsDetailes();
                // this.getPathCategories();

            }
        }
        // if (urlKey != null) {
        //     if (!this.item || this.item.custom_attributes[1].value != urlKey) {
        //         this.route.paramMap.subscribe(paramMap => {
        //             this.urlKey = paramMap.get('urlKey');
        //             // decodeURIComponent(this.urlKey)
        //             console.log(this.urlKey);
        //             this.fetchProductsDetailesByUrlKey();
        //             // this.getPathCategories();
        //
        //         });
        //     } else {
        //         this.urlKey = this.item.custom_attributes[1].value;
        //         this.fetchProductsDetailesByUrlKey();
        //         // this.getPathCategories();
        //
        //     }
        //
        // }

    }

    ngOnDestroy(): void {
        this.CatsLoadedEvent.unsubscribe();
    }

    fetchProductsDetailes() {

        this.googleService.eventEmitter("product_details_view", 'ecommerce', 'product_details_view', this.sku);

        return this.productService.getProductDetailsFull(this.sku).subscribe((product: any) => {
            this.item = product;
            this.titleService.setTitle("Alarabiya العربية - " + this.item.name);
            this.getPathCategories();


        });

    }


    fetchProductsDetailesByUrlKey() {
        return this.productService.getProductDetailsFullByURLKey(this.urlKey).subscribe((product: any) => {
            this.item = product;
            // this.getPathCategories();
            this.sku = this.item.sku;
            this.fetchProductsDetailes();

        });

    }


    getPathCategories() {
        this.breadScrumb = [];
        this.breadScrumbArr = [];
        const pathArr = this.item?.extension_attributes?.category_links;

        pathArr.forEach(e =>
            this.breadScrumb = this.breadScrumb.concat(this.FullCategories?.filter(v => v.id === Number(e.category_id)))
        );

        this.breadScrumb.forEach(e =>
            this.breadScrumbArr.push(new BreadcrumbModel(e?.name, '/web/home/categories/' + e?.id))
        );
        this.breadScrumbArr.splice(0, 1);


    }


}
